import colors from '@/config/colors';
import { useNavigation } from '@react-navigation/native';
import { StyleSheet, View } from 'react-native';
import { Text } from '@/components/Text';

import { SmallButton } from '@/components/Button';
import { Button } from '@/components/ui/therapist/Button';

export function NoPatient() {
  const { navigate } = useNavigation();

  return (
    <View style={styles.noPatientContainer}>
      <View style={{ alignItems: 'center' }}>
        <Text style={styles.noPatientTitle}>
          Noch keine Patient:innen erstellt
        </Text>
        <Button
          label="Profil hinzufügen"
          icon="userPlus"
          onPress={() => navigate('AddPatientScreen')}
        />
      </View>
      <View style={{ alignItems: 'center' }}>
        <Text style={styles.noPatientTitle}>Benötigen Sie Hilfe?</Text>
        <SmallButton
          label="Anleitung öffnen"
          onPress={() => navigate('Anleitung')}
        />
      </View>
    </View>
  );
}

const styles = StyleSheet.create({
  noPatientContainer: {
    flex: 1,
    justifyContent: 'space-evenly',
    alignItems: 'center',
    paddingVertical: 20,
    backgroundColor: colors.newUI.therapist.bgBlue10,
  },
  noPatientTitle: {
    fontSize: 30,
    color: colors.darkGrey,
    fontWeight: '700',
    marginBottom: 16,
  },
});
